export const aboutData = {
    title: "Who I am",
    description1: "My name's Md Shahbaz Alam. I'm a web developer and designer based in Koderma, jharkhand, India",
    description2: "⚡ I enjoy developing websites and a keen interest in solving problems and coming up with effective solutions ",
    description3: "⚡ Enjoy building responsive websites using ReactJs, material ui, MongoDB, Nodejs etc",
    image: 2
}